import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

import {
  FacilitatorChat,
  FasilitatorChatProps
} from '../../../components/facilitator/chat';
import {
  FacilitatorChatContext,
  FacilitatorChatContextProps
} from '../../../contexts/facilitator-chat';
import { GetTeamChatHistory } from '../../../services/teams';
import { ChatState } from '../../../types/state/websocket/chat-state';
import { GameContext } from '../../../contexts/game';

export const FacilitatorTeamChat = ({
  onSendMessage = () => {},
  ...props
}: FasilitatorChatProps) => {
  const { gameCode } = useParams();
  const auth = useAuth();

  const [game] = React.useContext(GameContext);
  const { chatHub } = React.useContext(
    FacilitatorChatContext
  ) as FacilitatorChatContextProps;

  const [messages, setMessages] = React.useState<ChatState[]>([]);

  const teamCode = props.item?.id ?? '';
  const players = React.useRef(game.gameState?.players ?? []);

  React.useEffect(() => {
    players.current = game.gameState?.players ?? [];
  }, [game.gameState?.players]);

  const getChatHistoryAsync = () => {
    let newChat: ChatState[] = [];
    GetTeamChatHistory(teamCode, gameCode!).then((response) => {
      response?.data.forEach((chat) => {
        newChat.push({
          author: {
            id:
              chat.playerCode === '00000000-0000-0000-0000-000000000000'
                ? auth?.user?.profile.sub!
                : chat.playerCode,
            name: chat.playerName,
            avatarUrl: chat.playerAvatar
          },
          timestamp: new Date(chat.sentDateUtc),
          group: 'team-chat',
          text: chat.message
        });
      });
      setMessages(newChat);
    });
  };

  const onTeamChatReceived = React.useCallback(
    (data: any) => {
      const { senderCode, senderName, senderAvatar, message, sentDateUtc } =
        data;

      const selectedPlayer = players.current.find((p) => p.code === senderCode);

      // receive chat only from player that joined in this team code room
      if (
        selectedPlayer &&
        selectedPlayer.teamCode &&
        selectedPlayer.teamCode === teamCode
      ) {
        const chat = {
          author: {
            id:
              senderCode === '00000000-0000-0000-0000-000000000000'
                ? auth?.user?.profile.sub!
                : senderCode,
            name: senderName,
            avatarUrl: senderAvatar,
            teamId: teamCode
          },
          timestamp: new Date(sentDateUtc),
          group: 'team-chat',
          text: message
        };
        setMessages((prev) => [...prev, chat]);
      }
    },
    [players, teamCode]
  );

  React.useEffect(() => {
    if (!chatHub || !teamCode) return;

    chatHub.on('TeamChatReceived', onTeamChatReceived);
  }, [chatHub, teamCode, onTeamChatReceived]);

  React.useEffect(() => {
    getChatHistoryAsync();
  }, [teamCode]);

  return (
    <FacilitatorChat
      item={props.item}
      messages={messages}
      onSendMessage={onSendMessage}
    />
  );
};
